let scriptsPromise;
let formQueue = Promise.resolve();
const initializedForms = new WeakMap();
const pageLoaded = document.readyState === "complete" ? Promise.resolve() : new Promise((resolve) => window.addEventListener("load", resolve, { once: true }));

function loadFormScripts() {
  if (!scriptsPromise) {
    // The external loader also listens for window.load. Load it afterwards so
    // only this initializer creates forms and reCAPTCHA widgets.
    scriptsPromise = pageLoaded.then(() => new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://forms.attityde.dk/form.min.js";
      script.dataset.cookieconsent = "ignore";
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        reject(new Error("Could not load Attityde Forms"));
      };
      document.head.appendChild(script);
    })).then(() => window.AttitydeForms.initScripts(!window.jQuery)).catch((error) => {
      scriptsPromise = null;
      throw error;
    });
  }

  return scriptsPromise;
}

export function initializeForm(element) {
  if (initializedForms.has(element)) return initializedForms.get(element);

  // Initialize sequentially: the external API checks for reCAPTCHA before
  // loading it, so simultaneous forms could otherwise load it more than once.
  const pending = formQueue.then(async () => {
    await loadFormScripts();
    if (element.dataset.lazyForm) element.dataset.form = element.dataset.lazyForm;
    await window.AttitydeForms.initForm(element);
  }).catch((error) => {
    initializedForms.delete(element);
    throw error;
  });

  initializedForms.set(element, pending);
  formQueue = pending.catch(() => {});
  return pending;
}

pageLoaded.then(() => {
  document.querySelectorAll("[data-form]").forEach((element) => {
    initializeForm(element).catch((error) => console.error("Could not initialize form", error));
  });
});
